import scrollIntoView, {
  StandardBehaviorOptions,
} from 'scroll-into-view-if-needed';

export const parseAnchorId = (id: string | undefined = ''): string => {
  let newId = id;
  if (id?.charAt(0) === '#') {
    newId = id.slice(1, id.length);
  }

  return newId;
};
type CommonProps = {
  id: string;
  areAppleDevicesPresent: boolean;
};

type YScrollProps = CommonProps & {
  topOffset?: number;
};

type XScrollProps = CommonProps & {
  boundary?: StandardBehaviorOptions['boundary'];
  leftOffset?: number;
};

export const scrollYToTargetAdjusted = ({
  id,
  areAppleDevicesPresent,
  topOffset = 0,
}: YScrollProps) => {
  const parsedId = parseAnchorId(id);
  if (!parsedId) return;
  let target = document.getElementById(parsedId || '');
  if (!target) return;

  if (areAppleDevicesPresent) {
    const targetPosition =
      target.getBoundingClientRect().top + window.scrollY - topOffset;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  } else {
    scrollIntoView(target, {
      scrollMode: 'if-needed',
      behavior: (actions) =>
        actions.forEach(({ el, top }) => (el.scrollTop = top - topOffset)),
      block: 'start',
    });
  }

  return;
};

export const scrollXToTargetIntoView = ({
  id = '',
  areAppleDevicesPresent,
  leftOffset = 0,
}: XScrollProps) => {
  const parsedId = parseAnchorId(id);
  if (!parsedId) return;
  let target = document.getElementById(parsedId || '');
  if (!target) return;

  const scrollContainer = target.parentElement;
  if (!scrollContainer) {
    return;
  }

  if (areAppleDevicesPresent) {
    // Calculate the target scroll position within the scroll container
    const targetPosition =
      target.getBoundingClientRect().left -
      scrollContainer.getBoundingClientRect().left +
      scrollContainer.scrollLeft -
      leftOffset;

    scrollContainer.scrollTo({
      left: targetPosition,
      behavior: 'smooth',
    });
  } else {
    scrollIntoView(target, {
      boundary: scrollContainer,
      block: 'end',
      inline: 'start',
      behavior: (actions) =>
        actions.forEach(({ el, left }) => (el.scrollLeft = left - leftOffset)),
    });
  }
  return;
};
